import React, { useState, useEffect, useRef } from 'react';
import Swal from 'sweetalert2';
import Breadcrumb from '@/components/common/Breadcrumb';
import { useSelector, useDispatch } from 'react-redux';
import validationErrors from '@/lib/validationErrors';
import { getRoleService, deleteRoleService } from '@/services/RoleServices';
import { cn } from '@/lib/utils';
import DataTable from './component/DataTable';
import AddEditModel from './component/AddEditModel';
import CustomDropdown from '@/components/common/CustomDropdown';
import PerPageSelection from '@/components/ui/tables/PerPageSelection';
import Card from '@/components/ui/cards/Card';
import CardHeader from '@/components/ui/cards/CardHeader';
import CardBody from '@/components/ui/cards/CardBody';
import RoleDataTable from './component/RoleDataTable';
import PermissionCheck from '@/components/common/PermissionCheck';

const RolePermissionPage = ({ pageTitle }) => {
    const dispatch = useDispatch();
    const [dataSource, setDataSource] = useState([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const [openModel, setOpenModel] = useState(null);
    const [editDataId, setEditDataId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [dataFilter, setDataFilter] = useState({
        search: '',
        page: 1,
        limit: 10,
    });
    const tableColumn = [
        { name: 'Name', isIncludePrint: true },
        { name: 'Status', isIncludePrint: true },
        { name: 'Action', isIncludePrint: false },
    ];

    useEffect(() => {
        getTableData();
    }, [dataFilter]);

    const handleModelOpen = (editId) => {
        if (editId && editId != '') {
            setEditDataId(editId);
        } else {
            setEditDataId('');
        }
        setOpenModel(true);
        document.body.style.overflowY = 'hidden';
    };

    const onChangeFilter = (name, value) => {
        setDataFilter({ ...dataFilter, [name]: value });
    };

    const getTableData = () => {
        setIsLoading(true);
        dispatch(getRoleService(dataFilter))
            .then((res) => {
                setTotalRecord(res?.data?.data?.total);
                setDataSource(res?.data?.data?.data);
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    const deleteRecord = (deleteId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {
            if (result.isConfirmed) {
                setIsLoading(true);
                dispatch(deleteRoleService(deleteId))
                    .then((res) => {
                        Swal.fire({
                            title: 'Deleted!',
                            text: 'Your record has been deleted.',
                            icon: 'success',
                        });
                        getTableData(dataFilter);
                        setIsLoading(false);
                    })
                    .catch(({ message, errorData, statusCode }) => {
                        validationErrors(errorData, message);
                        setIsLoading(false);
                    });
            }
        });
    };

    return (
        <>
            <Card>
                <CardHeader isBorder={true}>
                    <h3 className="db-card-title">Role & Permissions</h3>
                    <div className="db-card-filter">
                        <PermissionCheck permsission={'update_settings'}>
                            <button type="button" onClick={() => handleModelOpen('')} className={'db-btn h-[37px] text-white bg-primary'}>
                                <i className={'lab lab-add-circle-line'}></i>
                                Add Role
                            </button>
                        </PermissionCheck>
                    </div>
                </CardHeader>
                <CardBody className="p-0">
                    {/* <DataTable
                        isLoading={isLoading}
                        tableColumn={tableColumn}
                        dataSource={dataSource}
                        totalRecord={totalRecord}
                        dataFilter={dataFilter}
                        onChangePage={onChangeFilter}
                        handleModelOpen={handleModelOpen}
                        deleteRecord={deleteRecord}
                    /> */}
                    <RoleDataTable isLoading={isLoading} dataSource={dataSource} handleModelOpen={handleModelOpen} deleteRecord={deleteRecord} />
                </CardBody>
            </Card>
            <AddEditModel modelTitle={pageTitle} getTableData={getTableData} openModel={openModel} setOpenModel={setOpenModel} editDataId={editDataId} />
        </>
    );
};

export default RolePermissionPage;
